// @ts-nocheck
// import { initConfig } from './static'

// import Logger from '@sf-intl/reporter-sdk'
import { isOS } from '@/utils/constant'
import { getUrlKey } from '@/utils'
// import { LoggerGetSingleMaterial } from './materials'
import initConfig from '../../reporter/config/lg'
import { initJsResources } from './webVitals'
import { isUS } from '../constant'
import { LoggerGetSingleMaterial } from './materials'

// console.log("神策埋点-process.env.NODE_ENV", process.env.NODE_ENV);

// interface Event {
//   sceneType: string; // 页面
//   eventType: string; // 事件名称
//   resultType?: string; // 错误码
//   message?: string; // 额外消息
//   testType?: string; // 测试类型
// }

// interface EventProperty {
//   sceneType: string; // 事件名称
//   resultType: string; // 错误码
//   message: string; // 额外消息
//   testType: string; // 测试类型
// }

let Logger = null

let loggerReady = false

async function initReport() {
  if (isUS()) {
    return
  }
  Logger = await LoggerGetSingleMaterial()
  if (isOS() && window._global.ENV === 'PRD') {
    Logger.init({
      PROJECT: isOS() ? 'IBU-ICAS-CORE-OS' : 'IBU-ICAS-CORE', // 必填, app名称，用于区分不同项目

      IS_ENABLE: true, // 必填，默认为false,为false数据不会上报，且localStorage埋点相关数据会被清空,适用于GDRP安全协议

      IS_DEBUG: window._global['ENV'] !== 'PRD', // 必填，true 测试环境，type和event会自动在末尾加上'_sit'标识符，false 生成环境,'_sit'标识符去掉

      IS_STROAGE_ENABLE: true, // 必填， 默认为false,但是一般情况下必须为true,否则唯一客户号distinct_id将不会被缓存，false主要是为了处理有GDRP又需要上报的情况

      IS_SENDBEACON_ON: true, // 选填，默认为false, 支持用sendbeacon发送请求，减少页面跳转的埋点漏报率

      IS_PAGE_STAY_DURATION_ON: true, // 选填，默认为false, 计算页面停留时长

      IS_UPLOAD_EVENT_WITH_CACHE: false, // //默认false false:直接上传数据, true 缓存,可防止数据丢失，因为现在后台有数据上报成功但是因为跨域问题造成缓存还在的情况，造成数据重复上报，所以默认为false

      IS_USE_VUE_VIEW_TRACK: false, // 选填是否使用vue pv/uv自动采集上报中间件  ture使用vue-router中间件上报 Vue.use(Logger.viewTrack)，false使用默认方式上报

      AUTO_PERFORMANCE_TRACK: true, // 是否自动上报性能参数相关字段

      WITH_CREDENTIAL: false, // 默认为false，支持axios设置withCredential为false, true如果后端不支持有跨域问题，不影响别的axios请求

      URL: 'https://ibu-ibdp.sf.global/ibdp-data-access/writeData', // 必填,根据你当前系统服务器，顺丰云线上接入(内网环境)：http://dataaccess-ibu-ibdp-core.dcn.k8s.sf-express.com/ibdp-data-access/writeData 顺丰云线上接入(公网环境)：http://ibu-ibdp-access.sf-express.com/ibdp-data-access/writeData或者亚马逊云(https://ibu-ibdp.sf.global/ibdp-data-access/writeData)

      IS_PERFORMANCE_ANALYTICS_ON: true, // 是否开启开发者模式性能监控，默认为false

      THRESHOLD: 1, // 选填, 埋点累积到达阈值触发上传,1为直接上传，默认为1

      THRESHOLD_TIME: 3000, // 选填, 埋点累积到达指定时间阈值触发上传，ms为单位

      CLEAR_LOCALSTORAGE_THRESHOLD: 200, // 选填，当存量数据到达一定阈值没上报会清空，默认200， 防止localStorage不断堆积的情况

      ENABLE: true, // 选填, 是否开启行为日志采集,默认为true，注意，生产必须为true

      DEVICE_ID: '', // 【【【用户id，如有必要，请接入方在初始化的时候必要设置】】】选填, 打通APP到H5，有条件的可以提供app设备id方便跟踪app端到web端用户行为数据,不填写则会自动生成uuid-v4的唯一id缓存

      SYS_CODE: 'IBU-ICAS-CORE-OS', // 必填, 系统编码

      SECRECT_KEY: '18de3dacfb4d7673223e6e6c71f71110', // 必填, 接入私钥

      API: 'fvp.order.time', // 必填, 接口名固定

      ACCESS_KEY: 'a475877c2f8ff3570294714cb79ef5f5', // 必填, 接入编码

      // CLEAR_LOCALSTORAGE_THRESHOLD: 200, // 选填，当存量埋点到达200清空存量埋点，预防后台网络异常无法上传造成缓存堆积过多的情况,默认值200

      ERR_UPLOAD_TIMES_TO_CLEAN_DATA: -1, // 选填, 请求出错多少次会清空历史埋点缓存, 默认-1，不清除

      IS_ERROR_ANALYTICS_ON: false, // 选填，是否支持自动异常捕获，默认false

      IS_CROSS_ORIGIN_MODE_ON: false, // 通过<script src引入如果是跨域引入会造成捕获异常都为script error,可以设置为true解决（注意稳定性没进行验证）
    })
  } else {
    Logger.init(initConfig)
    Logger.registerPage({
      PROJECT: isOS() ? 'IBU-ICAS-CORE-OS' : null, // 必填, app名称，用于区分不同项目
      IS_ENABLE: true, // 必填，默认为false,为false数据不会上报，且localStorage埋点相关数据会被清空,适用于GDRP安全协议
      IS_DEBUG: false, // 必填，true 测试环境，type和event会自动在末尾加上'_sit'标识符，false 生成环境,'_sit'标识符去掉
      IS_STROAGE_ENABLE: false, // 必填， 默认为false,但是一般情况下必须为true,否则唯一客户号distinct_id将不会被缓存，false主要是为了处理有GDRP又需要上报的情况
      // 设置事件静/动态公共属性，需在 SDK 初始化之后调用
      platform_env: window._global['ENV'] === 'PRD' ? 'prd' : 'sit', // "prd/dev/sit/test"
      system_code: isOS() ? 'IBU-ICAS-CORE-OS' : 'IBU-ICAS-CORE-WEB', // os系统使用os
      URL: isOS() ? 'https://ibu-ibdp.sf.global/ibdp-data-access/writeData' : null, // 必填,根据你当前系统服务器，顺丰云线上接入(内网环境)：http://dataaccess-ibu-ibdp-core.dcn.k8s.sf-express.com/ibdp-data-access/writeData 顺丰云线上接入(公网环境)：http://ibu-ibdp-access.sf-express.com/ibdp-data-access/writeData或者亚马逊云(https://ibu-ibdp.sf.global/ibdp-data-access/writeData)
      platform_type: 'Web',
      platform_name: 'ICAS-PC',
      product_code: 'ICAS',
      intl_workCode: '',
    })

    // Logger.quick('autofalse')
    initJsResources()
    loggerReady = true
  }
}

export const initLogger = () => new Promise(resolve => {
  if (loggerReady) {
    // Logger.track(`intl_trigger`, properties)
    resolve(Logger)
    return
  }
  const inter = setInterval(() => {
    if (loggerReady) {
      clearInterval(inter)
      // Logger.track(`intl_trigger`, properties)
      resolve(Logger)
    }
  }, 100)
})

export const getLogger = () => {
  return Logger
}

/**
 *
 * @param {string} eventType //页面
 * @param {string} sceneType //事件名称
 * @param {string} resultType //错误码
 * @param {string} message //额外消息
 * @param {string} testType //测试类型
 * @param {string} consumeTime //交互过程中的耗时
 * @param {string} sessionId //环信会话id
 * @returns {any}
 */
export const $track = async(event) => {
  if (isUS() || !isOS()) {
    return
  }

  const Logger = await initLogger()
  const sysCode = getUrlKey('sysCode', location.href)
  const properties = {}
  if (event.sceneType) properties.intl_sceneType = event.sceneType
  if (event.eventType) properties.intl_eventType = event.eventType
  if (event.resultType) properties.intl_resultType = event.resultType
  if (event.testType) properties.intl_testType = event.testType
  if (event.message) properties.intl_message = event.message
  if (event.consumeTime) properties.intl_consume_time = event.consumeTime
  if (event.sessionId) properties.intl_session_id = event.sessionId
  if (event.redirectUrl) properties.intl_redirectUrl = event.redirectUrl
  if (event.sysCode || sysCode) properties.intl_sysCode = event.sysCode || sysCode
  Logger.track(`intl_trigger`, properties)
}

/**
 * todo 用不上 可以删了
 * @param {string} eventType //页面
 * @param {string} sceneType //事件名称
 * @param {string} resultType //错误码
 * @param {string} message //额外消息
 * @param {string} testType //测试类型
 * @returns {any}
 */
export const $view = async(event) => {
  if (isUS() || isOS()) {
    return
  }
  const Logger = await initLogger()
  const properties = {}
  if (event.sceneType) properties.intl_sceneType = event.sceneType
  if (event.eventType) properties.intl_eventType = event.eventType
  if (event.resultType) properties.intl_resultType = event.resultType
  if (event.testType) properties.intl_testType = event.testType
  if (event.message) properties.intl_message = event.message
  if (event.consumeTime) properties.intl_consume_time = event.consumeTime
  if (event.sessionId) properties.intl_session_id = event.sessionId
  if (event.redirectUrl) properties.intl_redirectUrl = event.redirectUrl
  if (event.sysCode) properties.intl_sysCode = event.sysCode

  Logger.track(`intl_trigger`, { type: 'click', event: properties.event })
}

export const $setProfile = async(data) => {
  if (isUS() || isOS()) {
    return
  }
  const Logger = await initLogger()
  Logger.setProfile(data) // 直接设置用户的属性，如果存在则覆盖
}

export const $setProperties = async(data) => {
  if (isUS() || isOS()) {
    return
  }
  const Logger = await initLogger()
  Logger.registerPage(data) // 更新覆盖公共属性的值
}

initReport()
